export function createQuery(host,iface,type, durationStart = "-60m", durationEnd = "0m", durationInterval = "5m") {
    var query = "";
    if (type === 'snmp'){
         query = `
from(bucket: "telegraf")  
  |> range(start: ${durationStart}, stop: ${durationEnd})
  |> filter(fn: (r) => r["_measurement"] == "interface")
  |> filter(fn: (r) => r["_field"] == "ifInErrors")
  |> filter(fn: (r) => r["agent_host"] == "${host}" and r["ifDescr"] == "${iface}")
  |> group(columns: ["host", "ifDescr"])
  |> last()
  |> keep(columns: ["agent_host", "interface", "value"])
            `

            return query;
        } 
 
    else {
        //    query = `
        //     from(bucket: "telegraf")
        //     |> range(start: ${durationStart}, stop: ${durationEnd})
        //     |> filter(fn: (r) => r["_measurement"] == "ezelink_interface_tx" or r["_measurement"] == "ezelink_interface_rx")
        //     |> filter(fn: (r) => r["type"] == "if_errors")
        //     |> filter(fn: (r) => r["host"] == "${host}")
        //     |> filter(fn: (r) => r["instance"] == "${iface}")
        //     |> aggregateWindow(every: ${durationInterval}, fn: mean, createEmpty: true)
        //     |> derivative(unit: 1s, nonNegative: true) // <-- this line gives you bytes/sec
        //     |> yield(name: "mean")
        //     `
        //     return query;
        query = `
            from(bucket: "telegraf")
            |> range(start: ${durationStart}, stop: ${durationEnd})
            |> filter(fn: (r) => r["_measurement"] == "ezelink_interface_tx" or r["_measurement"] == "ezelink_interface_rx")
            |> filter(fn: (r) => r["type"] == "if_errors")
            |> filter(fn: (r) => r["host"] == "${host}")
            |> filter(fn: (r) => r["instance"] == "${iface}")
            |> aggregateWindow(every: ${durationInterval}, fn: max, createEmpty: true)
            |> derivative(unit: 1s, nonNegative: true) 
            `
            return query;
            
    }
}